// Styles
import "src/assets/styles/main.scss";


// Bootstrap
// import * as bootstrap from 'bootstrap'

// Vue app
require('./scripts/main');

// Navigation
require('./scripts/navigation');
require('./scripts/accordion');

document.addEventListener('DOMContentLoaded', function () {

	// init eml
	let $eml = document.querySelectorAll(".eml");
	if ( $eml.length ) {
		[...$eml].forEach((link) => {
			let settings = {
				ext: 'info',
				domain: 'ecc-hsk',
				fulldom: '',
				nm: link.getHTML(),
				stylesStr: '',
				styles: link.getAttribute("style"),
				ttlStr: '',
				ttl: link.getAttribute("title"),
				classStr: '',
				classname: link.getAttribute("class"),
				dom: link.getAttribute("alt")
			};

			settings.fulldom = settings.domain + '.' + settings.ext;
			if (settings.styles) { settings.stylesStr = ' style=\"' + settings.styles + '\"'; }
			if (settings.ttl) { settings.ttlStr = settings.ttl; }
			if (settings.classname) { settings.classStr = ' class=\"' + settings.classname + '\"'; }
			if (settings.dom) { settings.fulldom = settings.dom; }

			link.innerHTML = '';
			if (settings.ttlStr.length>0) {
				link.insertAdjacentHTML('afterbegin', `<a${settings.stylesStr}${settings.classStr} href="mailto:${settings.nm}@${settings.fulldom}">${settings.ttlStr}</a>`);
			} else {
				link.insertAdjacentHTML('afterbegin', `<a${settings.stylesStr}${settings.classStr} href="mailto:${settings.nm}@${settings.fulldom}">${settings.nm}@${settings.fulldom}</a>`);
			}
		});
	}

});

let sr = document.querySelectorAll(".my-star");
let i = 0;
while (i < sr.length) {
	sr[i].addEventListener('click', function () {
		let cs = parseInt(this.getAttribute("data-star"));
		document.querySelector("#output").value = cs;
		let pre = cs;
		while (1 <= pre) {
			if (
				!document
					.querySelector(".star-" + pre)
					.classList.contains("is-active")
			) {
				document
					.querySelector(".star-" + pre)
					.classList.add("is-active");
			}
			--pre;
		}

		let succ = cs + 1;
		while (5 >= succ) {
			if (
				document
					.querySelector(".star-" + succ)
					.classList.contains("is-active")
			) {
				document
					.querySelector(".star-" + succ)
					.classList.remove("is-active");
			}
			++succ;
		}
	});
	i++;
}

document.addEventListener("DOMContentLoaded", function () {

	// Artikel: Zurück zur Uebersicht
	let backBtb = document.getElementById("back-button");
	if (backBtb) {
		backBtb.addEventListener('click', (event) => {
			window.location.href = `${
				event.target.closest("button").dataset.location
			}.html`;
		});
	}

});
